import {Component, Input} from '@angular/core';
import {PasswordParamsResponse} from '@primatoo-ms-organization';


@Component({
  selector: 'pt-input-password-help',
  template: `
    <span><b>{{'PASSWORD_HELP.LIST_INTRODUCTION' | translate}}</b></span>
    <ul>
      <li>{{'PASSWORD_HELP.LIST_ITEMS.LENGTH' | translate : { length: passwordHelpParams?.length } }}</li>
      <li>{{'PASSWORD_HELP.LIST_ITEMS.UPPER_CHARS' | translate : { upperChars: passwordHelpParams?.upperChars } }}</li>
      <li>{{'PASSWORD_HELP.LIST_ITEMS.LOWER_CHARS' | translate : { lowerChars: passwordHelpParams?.lowerChars } }}</li>
      <li>{{'PASSWORD_HELP.LIST_ITEMS.NUMBERS' | translate : { digits: passwordHelpParams?.digits } }}</li>
      <li>{{'PASSWORD_HELP.LIST_ITEMS.SPECIAL_CHARACTERS' | translate : {
        specials: passwordHelpParams?.specials,
        specialChars: passwordHelpParams?.specialChars
      } }}</li>
    </ul>
  `
})
export class InputPasswordHelpComponent {
  @Input() passwordHelpParams: PasswordParamsResponse;
}
